var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrations({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 145.5,
    height: 145.5,
    viewBox: "0 0 145.5 145.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 21.35,
    y1: 124.15,
    x2: 124.15,
    y2: 21.35,
    gradientTransform: "translate(121.8 -17.69) rotate(73.47)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9748a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d163ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 37.46,
    y1: 108.04,
    x2: 108.04,
    y2: 37.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edbede"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.75,
    cy: 72.75,
    r: 72.75,
    transform: "translate(-17.69 121.8) rotate(-73.47)",
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.52,35.45H44a10.91,10.91,0,0,0-10.9,10.89V99.16A10.91,10.91,0,0,0,44,110.05h57.54a10.91,10.91,0,0,0,10.9-10.89V46.34A10.91,10.91,0,0,0,101.52,35.45ZM44,40.45h57.54a5.9,5.9,0,0,1,5.9,5.89v7.8H38.08v-7.8A5.9,5.9,0,0,1,44,40.45Zm57.54,64.6H44a5.9,5.9,0,0,1-5.9-5.89v-40h69.34v40A5.9,5.9,0,0,1,101.52,105.05ZM59.89,76,53.83,82.1l6.06,6.05a2.52,2.52,0,0,1,0,3.54,2.51,2.51,0,0,1-3.54,0l-7.83-7.83a2.5,2.5,0,0,1,0-3.53l7.83-7.83A2.5,2.5,0,0,1,59.89,76ZM97,80.33a2.47,2.47,0,0,1,0,3.53l-7.82,7.83a2.51,2.51,0,0,1-3.54,0,2.52,2.52,0,0,1,0-3.54l6.06-6.05L85.61,76a2.5,2.5,0,0,1,3.54-3.54ZM83,68.77,76,96.64a2.49,2.49,0,0,1-2.42,1.89,2.13,2.13,0,0,1-.61-.08,2.49,2.49,0,0,1-1.81-3l7-27.87A2.5,2.5,0,0,1,83,68.77Z",
    fill: "url(#b)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrations);
export default __webpack_public_path__ + "static/media/integrations.157bed6a1b140386b332b8e9abac5bef.svg";
export { ForwardRef as ReactComponent };